import GetRelativeBalanceUseCase from "../../features/dep-parents/payments/usecases/get_relative_balance_usecase";
import { ValidateInvoiceProfileStatusUseCase } from "../../features/dep-parents/payments/usecases/validate_invoice_profile_status_usecase";
import SaveInvoiceDataUseCase from "../../features/dep-parents/usecases/save_invoice_data_usecase";

const SET_BALANCE_INFORMATION = "SET_BALANCE_INFORMATION";
const SET_SELECTED_CHILD = "SET_SELECTED_CHILD";
const SET_INVOICE_COMPLETED_STATUS = "SET_INVOICE_COMPLETED_STATUS";

const LOCAL_STORAGE_KEY = "_$RelativeBalance";

function initialState() {
  return localStorage.getItem(LOCAL_STORAGE_KEY)
    ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY))
    : {
        balance: [],
        selectedChild: null,
        isInvoiceProfileCompleted: null,
      };
}

const parentPaymentStore = {
  namespaced: true,

  state: initialState,

  mutations: {
    [SET_BALANCE_INFORMATION](state, balance) {
      state.balance = balance;
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state));
    },
    [SET_SELECTED_CHILD](state, userId) {
      state.selectedChild = state.balance.find((el) => el.idUserInt == userId);
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state));
    },
    [SET_INVOICE_COMPLETED_STATUS](state, isCompleted) {
      state.isInvoiceProfileCompleted = isCompleted;
    },
  },

  getters: {
    isReady(state) {
      return state.balance.length > 0;
    },
  },

  actions: {
    async initialize({ commit, dispatch, rootState }) {
      this._vm.$showLoading();
      const balanceOrFailure = await GetRelativeBalanceUseCase();
      dispatch("ShoppingCart/clearCart", null, { root: true });
      localStorage.removeItem(LOCAL_STORAGE_KEY);

      if (rootState.User.relative.invoiceRequired === true) {
        commit(SET_INVOICE_COMPLETED_STATUS, null);
        const isInvoiceProfileCompletedOrFailure =
          await ValidateInvoiceProfileStatusUseCase(rootState.User.uuid);

        isInvoiceProfileCompletedOrFailure.fold(
          () => commit(SET_INVOICE_COMPLETED_STATUS, false),
          ({ status }) => commit(SET_INVOICE_COMPLETED_STATUS, status)
        );
      }

      balanceOrFailure.fold(
        () => commit(SET_BALANCE_INFORMATION, []),
        (balance) => {
          if (balance.length === 0) {
            commit(SET_BALANCE_INFORMATION, []);
            this._vm.$hideLoading();
            return;
          }

          commit(SET_BALANCE_INFORMATION, balance);
          commit(SET_SELECTED_CHILD, balance[0].idUserInt);

          const unpaidPrograms = [];
          for (const item of balance) {
            const { idUserInt, programItemPeriod } = item;
            const unpaidProgramsForStudent = programItemPeriod.filter(
              (item) => item.program.isProgramBought == false
            );

            unpaidPrograms.push(
              ...unpaidProgramsForStudent.map((item) => ({
                key: `${idUserInt}_${item.program.childPrices.idAgreementDetailInt}`,
                type: "program",
                data: item,
              }))
            );
          }

          dispatch("ShoppingCart/addMultipleItemsToCart", unpaidPrograms, {
            root: true,
          });
        }
      );
      this._vm.$hideLoading();
    },

    selectChild({ commit }, userId) {
      commit(SET_SELECTED_CHILD, userId);
    },

    async saveNotInvoice({ rootState, dispatch }) {
      const request = {
        idUserInt: rootState.User.idInt,
        notInvoice: true,
      };

      await SaveInvoiceDataUseCase(request);
      const forceUpdate = true;
      await dispatch("User/loadUser", forceUpdate, { root: true });
    },
  },
};

export default parentPaymentStore;
